import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";

const IMG = "https://images.unsplash.com/photo-1693944844665-ce10f83a775b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      toast.success(`Bem-vinda de volta, ${data.name.split(" ")[0]}!`);
      navigate(data.role === "admin" ? "/admin" : "/area");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen overflow-hidden grid lg:grid-cols-2 bg-[#FCFCFA]">
      <div className="relative hidden lg:block h-screen">
        <img src={IMG} alt="Porto" className="w-full h-full object-cover" style={{ objectPosition: "center 62%" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#26130E]/70 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <Logo variant="light" className="h-12" />
          <p className="sc-label text-[#F7EEC7] mt-4">Porto · Membros</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 sm:px-12 py-16 h-screen overflow-y-auto">
        <div className="w-full max-w-md sc-fade-up">
          <Link to="/" className="sc-label text-[#6E5F58] hover:text-[#48020C]">← Voltar</Link>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#26130E] mt-6">Entrar</h1>
          <p className="text-[#6E6359] mt-3">Acede à tua zona de membro.</p>

          <form onSubmit={submit} data-testid="login-form" className="mt-10 space-y-6">
            <div className="space-y-2">
              <Label className="sc-label">Email</Label>
              <Input data-testid="login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="sc-input" placeholder="email@exemplo.com" />
            </div>
            <div className="space-y-2">
              <Label className="sc-label">Password</Label>
              <Input data-testid="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="sc-input" placeholder="A tua password" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-[#48020C] hover:bg-[#26130E] disabled:opacity-60 text-[#FCFCFA] font-medium rounded-full py-4 transition-colors">
              {loading ? "A entrar…" : "Entrar"}
            </button>
          </form>
          <p className="text-center text-sm text-[#6E6359] mt-6"><Link to="/recuperar-password" data-testid="forgot-password-link" className="text-[#6E5F58] hover:text-[#48020C] underline underline-offset-4">Recuperar password</Link></p>
          <p className="text-center text-sm text-[#6E6359] mt-3">Ainda não és membro? <Link to="/candidatura" className="text-[#48020C] underline underline-offset-4">Inscrever-me</Link></p>
        </div>
      </div>
      <style>{`.sc-input{background:#F4F1EA;border-color:#E3DED2;border-radius:0.75rem;padding:0.75rem 1rem;height:auto;}`}</style>
    </div>
  );
}
